import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {LogDto} from "@/store/player/types";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import { Tr } from "@/i18n/i18n";

export class LogPanel extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, l: LogDto) {
        super(scene);

        this.scene = scene;

        if(l.logType === 'GEMS') {
            let gemSprite = SpriteUtils.addSprite(this.scene, 254, 40, Keys.IMG_RES_MITHRIL);
            gemSprite.scale = 0.7;
            gemSprite.alpha = 0.8;
            this.add([gemSprite]);
        }

        let timeText = TextUtils.addTextAdvanced(scene, l.loggedAt + Tr('level') + String(l.playerLevel) + ', ' + Tr('emeralds.small') + String(l.playerMithril) + ')', -284, 22,
            '#ffdb60', 13, 'normal', 480, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        let descText = TextUtils.addTextAdvanced(scene, l.logText, -284, 42,
            '#e2e2e2', 13, 'normal', 480, 'left', 2, Fonts.MYRIADPRO_REGULAR);
        descText.setOrigin(0, 0)

        this.height = Math.max(70, descText.height + 45);

        const sep = SpriteUtils.addSprite(this.scene!, 0, this.height, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0.5, 0);

        this.add([timeText, descText, sep]);
    }

}
